module.exports = __webpack_public_path__ + "static/media/01.e0aa89d9.gif";